import PageHeader from "../../Components/PageHeader/PageHeader";
import EquipmentsMainTable from "../../Components/Equipments/EquipmentsMainTable";

const EquipmentListing = () => {

    return (

        <div>

            {/* HEADER */}
            <PageHeader />
           

            {/* SEARCH BOX AND MAIN TABLE*/}
            <EquipmentsMainTable />

        </div>

    );

}

export default EquipmentListing;
